module.exports = __webpack_public_path__ + "static/media/rams-womens-hoodie.bbb82348.png";